import RestResource from '../rest.service';
import Service from '../api.service';

export default class OrdersService extends RestResource {
  static _STATE_OPEN = 'open';
  static _STATE_PENDING = 'pending';
  static _STATE_ACCEPTED = 'accepted';
  static _STATE_REJECTED = 'rejected';
  static _STATE_CANCELED = 'canceled';
  static _STATE_TO_LIQUIDATE = 'to_liquidate';
  static _STATE_FINALIZED = 'finalized';

  map(payload) {
    return {
      producer_id: payload.producerId,
      campaign_id: payload.campaignId,
      stock_source: payload.stockSource || 'central',
      first_payment_date: payload.firstPaymentDate,
      billing_date: payload.billingDate,
      payments: payload.payments,
      dollar_quotation_id: payload.dollarQuotationId,
      dollar_quote: payload.dollarQuote,
      dollar_quote_date: payload.dollarQuoteDate,
      dollar_quotation_type: payload.dollarQuotationType,
      comment: payload.comment,
      status_change_comment: payload.statusChangeComment,
      projection_id: payload.projectionId ? payload.projectionId : null,
    };
  }

  availableArticles(id) {
    return Service.get(`${this.getResource({ id: id })}/available-articles`).catch(this.handleErrors);
  }

  stockSourceSuggestion({ campaignId, producerId, distributorId }) {
    return Service.get(`${this.resource}/stock-source-suggestion`, {
      params: {
        campaign_id: campaignId,
        ...(producerId ? { producer_id: producerId } : {}),
        ...(distributorId ? { distributor_id: distributorId } : {}),
      },
    }).catch(this.handleErrors);
  }

  controlledCorrection(id, mode = 'full') {
    return Service.get(`${this.getResource({ id: id })}/controlled-correction`, {
      params: { mode },
    }).catch(this.handleErrors);
  }

  correctSameVariety(id, payload) {
    return Service.put(`${this.getResource({ id: id })}/controlled-correction/same-variety`, payload).catch(
      this.handleErrors
    );
  }

  stateRoute(id, state) {
    return this.getResource({ id: id }) + '/' + state;
  }

  addProjection(order) {
    return Service.patch(this.getResource({ id: order.id }) + '/' + 'associate', this.map(order)).catch(
      this.handleErrors
    );
  }

  confirm(id) {
    return Service.patch(this.stateRoute(id, OrdersService._STATE_PENDING)).catch(this.handleErrors);
  }

  cancel(id, comment) {
    const data = { status_change_comment: comment };
    return Service.patch(this.stateRoute(id, OrdersService._STATE_CANCELED), data).catch(this.handleErrors);
  }

  accept(id, comment) {
    const data = { status_change_comment: comment };
    return Service.patch(this.stateRoute(id, OrdersService._STATE_ACCEPTED), data).catch(this.handleErrors);
  }

  reject(id, comment) {
    const data = { status_change_comment: comment };
    return Service.patch(this.stateRoute(id, OrdersService._STATE_REJECTED), data).catch(this.handleErrors);
  }

  getPdf(id, filename) {
    return Service.get(this.pdfResource(id), { responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }

  byMonths(id) {
    return Service.get(`${this.getResource({ id: id })}/concept-payments/by-months`).catch(this.handleErrors);
  }

  getDebt(id, params) {
    return Service.get(`${this.getResource({ id: id })}/debt`, { params: params }).catch(this.handleErrors);
  }

  getLiquidation(id, params) {
    return Service.get(`${this.getResource({ id: id })}/liquidation`, { params: params }).catch(this.handleErrors);
  }

  generateLiquidation(id) {
    return Service.post(`${this.getResource({ id: id })}/liquidation`).catch(this.handleErrors);
  }

  constructor() {
    super('orders');
  }
}
